// extracted by mini-css-extract-plugin
export var scrollArea = "_nd-0";